module.exports = __webpack_public_path__ + "static/media/map2.8140154d.jpg";